import * as React from "react";
import Collapse from "@material-ui/core/Collapse";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";

function ScheduleCancelHint() {
  const [open, setOpen] = React.useState(true);

  return (
      <Collapse in={open}>
        <Box mt={3}>
          <Paper>
        <Alert
          severity="info"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          Aufgrund der steigenden Corona-Fälle im Kreis Coesfeld finden zum Schutze aller die Spiele vorerst ohne Publikum statt.<br />
          <br />
          Aber ihr seid die besten Fans der Liga – deshalb haben wir für euch einen Live-Stream eingerichtet und freuen uns, wenn ihr online mitfiebert.<br />
          <Link href="https://www.twitch.tv/sgcoesfeld"><b>Zum Live Stream auf Twitch ›</b></Link>
        </Alert>
          </Paper>
        </Box>
      </Collapse>
  );
}

export default ScheduleCancelHint